import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, ModalBody, ModalFooter } from 'reactstrap';
import logolight from "../../assets/images/holcimlogoAdipi.png";
import { getEmaRegulations } from "../../store/actions";
import { BaseCustomModal, BaseCustomButton, GradientDecorationLine } from "../../shared";


const Footer = (props) => {

  // * Redux
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEmaRegulations("?limit=1000&page=0"))
  }, [dispatch])

  const emaRegulations = useSelector(state => state.emaRegulations.emaRegulations);

  const { className } = props;

  const [modal, setModal] = useState(false);

  // Build the current year to show in footer in a dynamic way
  const currentYear = new Date().getFullYear();

  const toggle = () => setModal(!modal);

  return (
    <React.Fragment>
      <footer className="footer" style={{ bottom: 0, left: props.props }}>

        <Container fluid={true}>

          <GradientDecorationLine />

          <div className="d-flex justify-content-between px-4">
            <div className="text-center">
              <img src={logolight} alt="" height="38" className="logo logo-dark" />
              <p className='mt-1'>Copyright © 2022-{ currentYear } DiPi - Digital Platform of Innovation | Holcim México V 2.0 </p>
            </div>
            <div className="text-center">
              <BaseCustomButton
                color='primary'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Acreditación ema'
                outline={true}
              />
            </div>
          </div>

          <BaseCustomModal
            title={<h4 className='text-primary ps-4 m-0'>{'Acreditación ema'}</h4>}
            isModalOpen={modal}
            handleOk={toggle}
            handleCancel={toggle}
            className={className}
            footer={null}
            centered
            style={{ maxWidth: '100%', margin: '0 auto', height: 'auto' }}
          >
            <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto' }}> 

              {emaRegulations.map((data, index) =>

                <div key={index}>
                  <GradientDecorationLine />
                  <label className="text-primary m-0">{data?.section}</label>
                  <br />
                  <div>{data?.development}</div>
                  <GradientDecorationLine />
                </div>
              )}

            </ModalBody>

            <ModalFooter className="text-center">
              <BaseCustomButton
                color='primary'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Ok'
                outline={true}
              />
            </ModalFooter>

          </BaseCustomModal>

        </Container>

      </footer>

    </React.Fragment>

  )
}

export default Footer